import React from 'react';
import SvgCheck from '@icons/check.svg?react';
import clsx from 'clsx';

export enum Mode {
  Active = 'active',
  Checked = 'checked',
  Disabled = 'disabled',
  Required = 'required',
}

interface ComponentProps {
  label: string;
  onClick: () => void;
  checked: boolean;
  mode: Mode;
  dataTestId?: string;
  // Whether to render the check icon on the selected state. Defaults to true; pass false for
  // segmented range/role pickers that shouldn't show it.
  showCheckIcon?: boolean;
}

export const SelectableButton: React.FC<ComponentProps> = ({ label, onClick, checked, mode, dataTestId, showCheckIcon = true }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={dataTestId}
      className={clsx(
        "flex h-10 p-4 rounded font-['DM Sans'] text-sm font-medium leading-[12px] items-center gap-2",
        mode === Mode.Checked ? "text-content-brand bg-content-brandMedium border border-solid border-content-brand" : "",
        mode === Mode.Active ? "text-content-secondary bg-content-quaternary border border-solid border-content-quaternary" : "",
        mode === Mode.Disabled ? "text-content-tertiary bg-content-quaternary border border-solid border-content-quaternary" : "",
        mode === Mode.Required ? "text-content-primary bg-complementary-warningMedium border border-solid border-content-secondary" : "",
      )}
    >
      {checked && showCheckIcon && <SvgCheck className="w-4 h-4" />}
      <span>{label}</span>
    </button>
  );
};